import {
    Component,
    EventEmitter,
    Input,
    Output,
    OnInit,
    ViewChild,
    ElementRef
} from '@angular/core';
import { LazyLoadEvent, TreeNode, MessageService } from 'primeng/api';
import { TreeTable } from 'primeng/treetable';
import { IdName } from '../domain/idname';
import { TreeAccountsComponent } from './tree-accounts.component';
import { Totaling } from '../domain/totaling';
import { AccountService } from '../service/account.service';
import { ChipsModule } from 'primeng/chips';
import { ReportDefinitionService } from '../service/reportdefinition.service';
import { ɵAnimationRendererFactory } from '@angular/platform-browser/animations';
import * as _ from 'lodash';

@Component({
    selector: 'app-filter-picker',
    templateUrl: './filter-picker.component.html',
    styles: [
        `
            :host ::ng-deep .priority-2,
            :host ::ng-deep .priority-3,
            :host ::ng-deep .visibility-sm {
                display: none;
            }

            ::ng-deep .your-table .ui-treetable-scrollable-view .ui-treetable-scrollable-body {
                min-height: 300px !important;
            }

            @media screen and (max-width: 39.938em) {
                :host ::ng-deep .visibility-sm {
                    display: inline;
                }
            }

            @media screen and (min-width: 40em) {
                :host ::ng-deep .priority-2 {
                    display: table-cell;
                }
            }

            @media screen and (min-width: 64em) {
                :host ::ng-deep .priority-3 {
                    display: table-cell;
                }
            }
        `
    ]
})
export class FilterPickerComponent implements OnInit {
    constructor(
        private accountService: AccountService,
        private reportDefinitionService: ReportDefinitionService
    ) {
        this.contextMenuItems = [
            {
                label: 'Collapse All',
                icon: 'ui-expand-less',
                command: event => this.collapse()
            },
            {
                label: 'Expand All',
                icon: 'ui-expand-more',
                command: event => this.expand()
            }
        ];

        this.tableColumns = [{ field: 'code', header: 'Code', width: '20%' }, { field: 'name', header: 'Name', width: '80%' }];
    }

    @Input() reportId: number;
    @Input() filterAccounts: IdName[];

    @Output() change: EventEmitter<IdName[]> = new EventEmitter<IdName[]>();

    displayFilter: boolean = false;
    accountsForFilterExist: boolean;
    accountsForFilter: TreeNode[];
    selectedAccountFilter: TreeNode[];
    contextMenuItems: any[];
    tableColumns: any[];
    filterIds: string;

    ngOnInit() {
        //this.setExistingFilterAccounts();
    }

    setExistingFilterAccounts() {
        this.reportDefinitionService.getFilterAccounts(this.reportId).then(o => {
            this.filterAccounts = o;
        });
    }

    recursivelyRemove(dataArray, id)
    {
        dataArray.foreach(d => {
            if (Array.isArray(d))
            {
                this.recursivelyRemove(d, id);
            }
            else
            {
                if (d.id == id)
                {

                }
            }
        });
    }

    setFilterIds(accounts: IdName[])
    {
        this.filterIds = "";
        var filterIdsArray: number[] = [];
        accounts.forEach(element => {
            filterIdsArray.push(element.id);
        });
        this.filterIds = filterIdsArray.join(",");
    }

    openFilterPicker() {

        this.setFilterIds(this.filterAccounts);

        this.accountService.getAllForFilterList(this.reportId.toString(), this.filterIds).then(data => {
            this.accountsForFilter = data;

            if (this.accountsForFilter && this.accountsForFilter.length > 0) {
                this.accountsForFilterExist = true;
            }
            else {
                this.accountsForFilterExist = false;
            }

            this.displayFilter = true;
        });
    }

    collapse() {
        if (this.accountsForFilter) {
            this.accountsForFilter.forEach(node => {
                this.expandRecursive(node, false);
            });
            this.accountsForFilter = [...this.accountsForFilter];
        }
    }

    private expandRecursive(node: TreeNode, isExpand: boolean) {
        node.expanded = isExpand;
        if (!node.leaf && node.children !== null) {
            node.children.forEach(childNode => {
                this.expandRecursive(childNode, isExpand);
            });
        }
    }

    expand() {
        this.accountsForFilter.forEach(node => {
            this.expandRecursive(node, true);
        });
        this.accountsForFilter = [...this.accountsForFilter];
    }

    addNewAccountToFilter() {
        if (this.filterAccounts === undefined) {
            this.filterAccounts = Array<IdName>();
        }

        this.selectedAccountFilter.forEach(element => {
            let chip = new IdName();
            chip.id = element.data.id;
            chip.name = element.data.code;
            chip.desc = element.data.name;
            this.filterAccounts.push(chip);
        });

        this.selectedAccountFilter = [];
        this.displayFilter = false;
    }

    removeAccount(account: IdName) {
        this.change.emit(this.filterAccounts);
    }
}
